// src/data/gyms/NorthernLights.js
export const NorthernLights = {
  id: "northernlights",
  name: "Northern Lights All Stars",
  color: "#8B5CF6", // Aurora Purple/Green mix - using Purple for contrast
  lightColor: "#F3E8FF",
  logo: "✨",

  teams: [
    { id: "bumblebees", name: "Bumblebees", level: "L1 Tiny - Novice" },
    { id: "lemonade", name: "Lemonade", level: "L1 Junior - Novice" },
    { id: "butterscotch", name: "Butterscotch", level: "L1 Youth - Novice" },
    { id: "legacy", name: "Legacy", level: "L4 Senior Coed - D2" },
    { id: "goldengirls", name: "Golden Girls", level: "L2 Youth - Flex - D2" },
    { id: "electric", name: "Electric", level: "L3 Junior - Flex - D2" },
    { id: "honey", name: "Honey", level: "L1 Junior - Flex - D2" },
    { id: "sunnies", name: "Sunnies", level: "L1 Mini - D2" },
    { id: "jackpot", name: "Jackpot", level: "L5 Senior Coed - D2" },
    { id: "luckycharms", name: "Lucky Charms", level: "L1 Tiny - D2" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "9:38 AM",
      teamId: "bumblebees",
      meet: "9:02 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "10:13 AM",
      teamId: "lemonade",
      meet: "9:37 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "10:16 AM",
      teamId: "butterscotch",
      meet: "9:40 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "11:25 AM",
      teamId: "legacy",
      meet: "10:49 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "11:35 AM",
      teamId: "goldengirls",
      meet: "10:59 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "12:07 PM",
      teamId: "electric",
      meet: "11:31 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "1:40 PM",
      teamId: "honey",
      meet: "1:04 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "2:47 PM",
      teamId: "sunnies",
      meet: "2:11 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "3:44 PM",
      teamId: "jackpot",
      meet: "3:08 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "3:51 PM",
      teamId: "luckycharms",
      meet: "3:15 PM",
      panel: "Hall A",
    },

    // ================= SUNDAY (Dec 14) =================
    {
      day: "Sunday",
      time: "9:28 AM",
      teamId: "legacy",
      meet: "8:52 AM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "9:38 AM",
      teamId: "goldengirls",
      meet: "9:02 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "10:10 AM",
      teamId: "electric",
      meet: "9:34 AM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "10:48 AM",
      teamId: "honey",
      meet: "10:12 AM",
      panel: "Hall B",
    },

    // Found on PDF Row 195
    {
      day: "Sunday",
      time: "12:35 PM",
      teamId: "sunnies",
      meet: "11:59 AM",
      panel: "Hall A",
    },

    // Found on PDF Row 210
    {
      day: "Sunday",
      time: "2:17 PM",
      teamId: "jackpot",
      meet: "1:41 PM",
      panel: "Hall A",
    },

    // Found on PDF Row 212
    {
      day: "Sunday",
      time: "2:24 PM",
      teamId: "luckycharms",
      meet: "1:48 PM",
      panel: "Hall A",
    },
  ],
};
